import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const HelpCenterWrapper = styled.div``;

export const HelpCenterHeader = styled.div`
    padding: 70px 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 23px;
`;

export const HelpCenterContent = styled.div`
    width: 100%;
    background-color: #f9f9f9;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 26px 50px;
    padding: 60px;
`;

export const HelpCenterCard = styled.div`
    padding: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 10px 20px rgba(136, 104, 234, 0.1);
    border-radius: 14px;
    gap: 10px;
    max-width: 290px;
    ${Text.Style} {
        text-align: center;
    }
    svg {
        font-size: 50px;
        color: ${theme.colors.purple.primary};
    }
`;
